import Label from '../../../components/Label';
import SvgIconStyle from '../../../components/SvgIconStyle';
import { NavSubheaderProps } from '../../../components/nav-section/type';
import { PermissionCode } from '../../../constants/permissions';
import { tokens } from '../../../locales/tokens';
import { PATH_DASHBOARD } from '../../../routes/paths';

// ----------------------------------------------------------------------

const getIcon = (name: string) => (
  <SvgIconStyle src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  food: getIcon('ic_food'),
  dining: getIcon('ic_dining'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  bookmark: getIcon('ic_bookmark'),
  crown: getIcon('ic_crown'),
  order: getIcon('ic_invoice'),
  inventory: getIcon('ic_inventory'),
  invoice: getIcon('ic_invoice'),
  receipt: getIcon('ic_receipt'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  store: getIcon('ic_store'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  menuItem: getIcon('ic_menu_item'),
  security: getIcon('ic_security'),
};

const navConfig: NavSubheaderProps[] = [
  {
    subheader: tokens.nav.general,
    permissions: ['dashboard.read', 'analytics.read', 'tabs.read', 'orders.read'] as PermissionCode[],
    items: [
      {
        title: tokens.nav.app,
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
        permissions: ['dashboard.read'] as PermissionCode[],
      },
      {
        title: tokens.nav.analytics,
        path: PATH_DASHBOARD.general.analytics,
        icon: ICONS.analytics,
        permissions: ['analytics.read'] as PermissionCode[],
        planFeature: 'analytics' as const,
      },
      {
        title: tokens.nav.tabs,
        path: PATH_DASHBOARD.tab.root,
        icon: ICONS.bookmark,
        permissions: ['tabs.read'] as PermissionCode[],
        planFeature: 'tabs' as const,
      },
      {
        title: tokens.nav.orders,
        path: PATH_DASHBOARD.order.root,
        icon: ICONS.food,
        permissions: ['orders.read'] as PermissionCode[],
        tourKey: 'navbar-orders-step',
      },
    ],
  },

  {
    subheader: tokens.nav.management,
    permissions: ['users.read', 'inventory.read', 'invoices.read', 'security.read'] as PermissionCode[],
    items: [
      {
        title: tokens.nav.users,
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user,
        permissions: ['users.read'] as PermissionCode[],
        tourKey: 'navbar-users-step',
      },
      {
        title: tokens.nav.inventory,
        path: PATH_DASHBOARD.inventory.root,
        icon: ICONS.inventory,
        permissions: ['inventory.read'] as PermissionCode[],
        planFeature: 'inventory' as const,
        info: <Label color="info">Novo</Label>,
        tourKey: 'navbar-inventory-step',
        children: [
          { title: tokens.nav.inventoryControl, path: PATH_DASHBOARD.inventory.control },
          { title: tokens.nav.statement, path: PATH_DASHBOARD.inventory.statement },
        ],
      },
      {
        title: tokens.nav.invoices,
        path: PATH_DASHBOARD.invoice.root,
        icon: ICONS.invoice,
        permissions: ['invoices.read'] as PermissionCode[],
        tourKey: 'navbar-invoices-step',
      },
      {
        title: tokens.nav.security,
        path: PATH_DASHBOARD.security.profiles,
        icon: ICONS.security,
        permissions: ['security.read'] as PermissionCode[],
        tenant: 'all',
      },
    ],
  },

  {
    subheader: tokens.nav.organization,
    permissions: ['venues.read', 'menu.read', 'billing.read', 'billing.manage'] as PermissionCode[],
    items: [
      {
        title: tokens.nav.venues,
        path: PATH_DASHBOARD.venue.root,
        icon: ICONS.store,
        permissions: ['venues.read'] as PermissionCode[],
        tenant: 'all',
        tourKey: 'navbar-venues-step',
      },
      {
        title: tokens.nav.globalMenu,
        path: PATH_DASHBOARD.eCommerce.root,
        icon: ICONS.dining,
        permissions: ['menu.read'] as PermissionCode[],
        children: [
          { title: tokens.nav.general, path: PATH_DASHBOARD.eCommerce.list },
          { title: tokens.nav.categories, path: PATH_DASHBOARD.eCommerce.categories },
          { title: tokens.nav.products, path: PATH_DASHBOARD.eCommerce.products },
        ],
      },
      {
        title: tokens.nav.billing,
        path: PATH_DASHBOARD.organization.subscription,
        icon: ICONS.crown,
        permissions: ['billing.read', 'billing.manage'] as PermissionCode[],
        tenant: 'all',
      },
    ],
  },
];

export default navConfig;
